<template>
  <div id="login-container">
      <!-- <div style="height:100px;line-height:100px;border-bottom:3px solid #8faadc;text-align:left;">
        <a href="/RC" style="display:inline-block;height:100px;line-height:100px;">
          <img src="../assets/logo_1.svg" style="height:80px;padding-top:13px;margin-left:40px;" />
        </a>
        <span style="display:inline-block;height:40px;line-height:40px;border-right:3px solid #8faadc;margin-bottom:23px;"></span>
        <span style="display:inline-block;position:absolute;margin-left:20px;font-size:30px;font-weight:bold;color:#8faadc;min-width:270px;">关键人才激发与保留系统</span>
      </div> -->
      <div style="min-height:600px;min-width:1080px;">
        <!-- <div><img style="position:absolute;top:30%;left:10%;" src="../assets/main.png" /></div> -->
        <!-- <div style="width:55%;display:inline-block;margin-top:8%;min-width:600px;margin-right:3%;margin-left:1%;"><img src="../assets/main.png" style="width:600px;"/></div> -->
        <div class="login_poetry">
          <img src="../assets/login_logo_new.png" style="width:355px;margin-top:20px;">
        </div>
        <div style="width:500px;height:500px;display:inline-block;border-radius:10px;box-shadow:0px 4px 4px 4px rgba(0, 0, 0, 0.08);background:#ffffff;font-size:12px;font-weight:400;color:#000000;vertical-align:middle;margin-top:10%;">
          <el-form ref="form" :model="form" label-width="65px" class="login-form" :rules="rules">
              <!-- <div style="height:70px;line-height:70px;border-bottom:2px solid #8faadc;"><span class="login-title">请使用账号密码登录</span></div> -->
              <div style="width:500px;height:60px;margin-top:50px;">
                <img src="../assets/system_name_left.png" style="display:inline-block;margin-bottom:5px;width:70px;margin-right:15px;">
                <span style="font-size:24px;line-height:60px;color:#333333;">关键人才激发与保留系统</span>
                <img src="../assets/system_name_right.png" style="display:inline-block;margin-bottom:5px;width:70px;margin-left:15px;">
              </div>
              <!-- <el-form-item label="" prop="username">
                  
              </el-form-item> -->
              <el-input v-model="form.username" placeholder="请输入邮箱地址" style="margin-top:50px;"></el-input>
              <!-- <el-form-item label="" prop="password">
                  
                  
              </el-form-item> -->
              <!-- 增加keyup.enter.native，即输入完密码直接回车也可执行登录 -->
              <el-input v-model="form.password" type="password" placeholder="请输入密码" @keyup.enter.native="Login" style="margin-top:20px;"></el-input>
              <!-- <p class="err">{{ errmsg }}</p> -->
              <!-- <div class="forget_passwd"><el-button type="text" size="mini" style="color:#8faadc;" @click="reset_passwd">忘记密码</el-button></div> -->
              <el-button type="primary" style="margin-top:50px;" @click="Login">登录</el-button>
              <div style="margin-top:70px;height:50px;line-height:50px;text-align:left;">
                <img src="../assets/know_system.png" style="display:inline-block;width:21px;margin-left:32px;" />
                <el-link :underline="false" href="https://kdocs.cn/l/ciUdagqRqkBP" target="_blank" style="font-size:14px;color:#333333;padding-bottom:15px;margin-left:10px;">了解系统</el-link>
                <img src="../assets/start_use.png" style="display:inline-block;width:21px;margin-left:85px;" />
                <el-popover placement="top" title="" trigger="hover">
                  <el-link :underline="false" slot="reference" style="font-size:14px;color:#333333;padding-bottom:15px;margin-left:10px;">开始使用</el-link> 
                  <img src="../assets/contact.jpg" style="width:300px;height:300px" />
                </el-popover>
                <img src="../assets/contact_us.png" style="display:inline-block;width:21px;margin-left:85px;" />
                <el-popover placement="top" title="" trigger="hover">
                  <el-link :underline="false" slot="reference" style="font-size:14px;color:#333333;padding-bottom:15px;margin-left:10px;">联系我们</el-link>
                  <img src="../assets/contact.jpg" style="width:300px;height:300px" />
                </el-popover>
              </div>
          </el-form>
        </div>
      </div>
      <div style="position:absolute;bottom:50px;text-align:center;width:100%;"><a href="https://beian.miit.gov.cn" class="beian" target="_blank"><span style="color:#cccccc;font-size:12px;">苏ICP备2022021755号-1</span></a></div>
      <!-- <el-dialog class="reset_passwd_dialog" title="找回密码" :visible.sync="forget_passwd_dialog" width="400px" :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
        <el-form ref="form" :model="forget_passwd_form" label-width="80px">
            <el-form-item label="邮箱地址" prop="email">
                <el-input v-model="forget_passwd_form.email" placeholder="请输入登录邮箱地址"></el-input>
            </el-form-item>
            <div style="text-align:center;line-height:40px;">
                <el-button @click="cancle_chg">取 消</el-button>
                <el-button type="primary" @click="submit_chg">确 定</el-button>
            </div>
        </el-form>
      </el-dialog> -->
  </div>
</template>

<script>
// @ is an alias to /src
import postdata from "@/api/postData.js";

export default {
  data() {
      return {
          form: {
              username: '',
              password: '',
          },
          forget_passwd_form: {
              email: '',
          },
          // errmsg: '',
          rules: {
            // trigger类型为blur的功能是文本框失去焦点才会触发
            // trigger类型为change的功能是文本框在输入内容时触发
            username: [
              {required: true, message: '请输入用户名！', trigger: 'blur'},
              {type: 'email', message: '请输入正确的邮箱地址！', trigger: 'blur'},
            ],
            password: [
              {required: true, message: '请输入密码！', trigger: 'blur'},
              // {min: 6, max: 12, message: '密码长度为6~12个字符！', trigger: ['blur', 'change']},
              // {pattern: /^[A-Za-z0-9_]{1}[A-Za-z0-9_!@#$%^&*]{5,11}$/, message: '密码需要同时包含数字、字母和特殊字符(! @ # $ % ^ & * _)，仅能使用数字和字母开头！', trigger: ['blur', 'change']}
            ],
          },
          forget_passwd_dialog: false,
      }
  },
  methods: {
      reset_passwd() {
          if(this.form.username != ''){
            this.forget_passwd_form.email = this.form.username;
          }
          this.forget_passwd_dialog = true;
      },
      cancle_chg() {
          this.forget_passwd_dialog = false;
      },
      submit_chg() {
          if(this.forget_passwd_form.email == ''){
            this.$message({
                message: "请输入登录邮箱地址！",
                type: "error",
                duration: 6000,
                // showClose: true,
              })
            return;
          }
          postdata.postList("resetPasswd", JSON.stringify(this.forget_passwd_form))
            .then(resp => {
            if(resp.data.code == 200){
              this.$message({
                message: resp.data.message,
                type: "success",
                duration: 1500,
              })
              this.forget_passwd_dialog = false;
            }else{
              this.$message({
                message: resp.data.message,
                type: "error",
                duration: 6000,
                // showClose: true,
              })
            }
          })
          .catch(() => {
          })
      },
      Login() {
        if(this.form.username == '' || this.form.password == ''){
          this.$message({
            message: "用户名或密码为空！",
            type: "error",
            duration: 6000,
            // showClose: true,
          })
          return;
        }else{
          // 增加对用户名（邮箱）格式的判定
          var reg = '^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\\.[a-zA-Z0-9_-]+)+$';
          //调用正则验证test()函数
          if(!this.form.username.match(reg)) {
            this.$message({
              message: "用户名格式错误，请使用正确的邮箱名！",
              type: "error",
              duration: 6000,
              // showClose: true,
            })
            return;
          }
          // 后端验证
          postdata.postList("loginRC", JSON.stringify(this.form))
              .then(resp => {
                // this.errmsg = resp.data;
                // setTimeout(this.clearErrMsg, 3000);
                var msgtype = "";
                if(resp.data.code == 200){
                  msgtype = "success";
                  this.$message({
                    message: resp.data.message,
                    type: msgtype,
                    duration: 1500,
                  })
                  var usertype = resp.data.data.usertype;
                  localStorage.setItem('token', resp.data.data.token);
                  localStorage.setItem('username', this.form.username);
                  // this.$router.go(-1);   路径上使用了参数，貌似用这个跳转不了到上一页，使用下面的方法可以
                  // window.history.back();
                  if(usertype=='sadmin'){
                    this.$router.push({
                        path: '/RC/sysconf',
                    });
                  }else{
                    this.$router.push({
                        path: '/RC',
                    });
                  }
                }else{
                  msgtype = "error";
                  this.$message({
                    message: resp.data.message,
                    type: msgtype,
                    duration: 6000,
                    // showClose: true,
                  })
                }
                // console.log("token: " + localStorage.getItem('token'));
              })
              .catch(err => {
                console.log(err);
              })
        }
      },
  }
};
</script>

<style scoped>
  .login-form {
      width: 500px;
      background-color: #fff;
      /* padding: 15px; */
      /* border-radius: 5px; */
      height: 430px;
      /* right: 10%;
      top: 45%;
      margin-left: -175px;
      margin-top: -125px;
      position: absolute; */
      /* border: 3px solid #8faadc; */
  }
  #login-container {
      margin: -8px;
      min-width: 1080px;
      /* position: absolute;
      width: 99%;
      height: 99%; */
  }
  .login-title {
      color: #8faadc;
      text-align: center;
      font-size: 27px;
      font-weight: bold;
      color: #8faadc;
  }
  .err {
      color:crimson;
  }
  ::v-deep .el-form-item__error {
      text-align: left;
  }
  ::v-deep .el-button {
      width: 440px;
      height: 54px;
      font-size: 18px;
      /* margin-top: 20px; */
  }
  ::v-deep .el-button--primary {
    background-color: #42b6ff;
    border-color: #42b6ff;
  }
  ::v-deep .el-input__inner {
      width: 440px;
      height: 48px;
      line-height: 48px;
      font-size: 14px;
      border: 1px solid #cccccc;
      border-radius: 5px;
  }
  ::v-deep .el-link {
      font-size: 22px;
      color: #8faadc;
  }
  .forget_passwd {
    text-align: right;
    width: 360px;
  }
  .forget_passwd /deep/ .el-button {
      font-size: 18px;
      margin-top: 0px;
      width: 72px;
      padding-left: 25px;
  }
  .reset_passwd_dialog /deep/ .el-input__inner {
      width: 250px;
      height: 40px;
      line-height: 40px;
      font-size: 14px;
      border: 1px solid #dcdfe6;
  }
  .reset_passwd_dialog /deep/ .el-dialog__header {
      text-align: left;
  }
  .reset_passwd_dialog /deep/ .el-button {
      font-size: 14px;
      width: 73.9px;
      height: 40px;
  }
  .reset_passwd_dialog /deep/ .el-button--primary {
    background-color: #409eff;
    border-color: #409eff;
  }
    .beian {
    text-decoration: none;
  }
  .beian :hover {
    text-decoration: underline;
  }
  .login_poetry {
    display: inline-block;
    width: 480px;
    height: 480px;
    background-image: url("../assets/login_poetry_rc.png");
    background-repeat: no-repeat;
    margin-top: 10%;
    vertical-align: middle;
    margin-top: 10%;
    margin-right: 100px;
  }
</style>